export default __webpack_public_path__ + "static/media/7777BLEU.f085c4ff.pdf";